/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
/* eslint-disable react/jsx-no-comment-textnodes,jsx-a11y/click-events-have-key-events,no-bitwise */
import React from 'react';
import PropTypes from 'prop-types';
import Popover from '@mui/material/Popover';
import { SketchPicker } from 'react-color';
import InputLabel from "@mui/material/InputLabel";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputAdornment from "@mui/material/InputAdornment";

/* eslint-disable react/forbid-prop-types */
export default class ColorComponent extends React.Component {
	static propTypes = {
		color: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
		label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
		// width: PropTypes.number,
		transparent: PropTypes.bool,
		disableAlpha: PropTypes.bool,
		onChange: PropTypes.func.isRequired,
	}

	static defaultProps = {
		// width: 100,
		label: undefined,
		transparent: false,
		disableAlpha: true,
	};

	constructor(props) {
		super(props);

		this.state = {
			displayPicker: false,
			color: props.color,
			label: props.label,
		};
	}

	static getDerivedStateFromProps(props, state) {
		return { ...state, color: props.color };
	}

	// componentWillReceiveProps(nextProps) {
	// 	this.setState({ color: nextProps.color });
	// }
	//
	handleColorClick = (event) => {
		// This prevents ghost click.
		event.preventDefault();

		this.setState({
			displayPicker: true,
			anchorEl: event.currentTarget,
		});
	};

	handleColorClose = () => {
		this.setState({ displayPicker: false });
	};

	handleColorChange = (color) => {
		if (this.props.disableAlpha) {
			this.setState({color: color.hex});
			this.props.onChange(color.hex);
		} else {
			this.setState({color: color.rgb});
			this.props.onChange(color.rgb);
		}
	};

	getBackground() {
		if (this.state.color === undefined) {
			return 'white';
		}
		return this.state.color.a !== undefined ? `rgba(${this.state.color.r},
											${this.state.color.g}, ${this.state.color.b},
											${this.state.color.a})` : this.state.color;
	}

	getPresetColors() {
		const colors =
			["#000000", "#434343", "#666666", "#999999", "#B7B7B7", "#CCCCCC", "#D9D9D9", "#EFEFEF", "#F3F3F3", "#FFFFFF",
				"#980000", "#FF0000", "#FF9900", "#FFFF00", "#00FF00", "#00FFFF", "#4A86E8", "#0000FF", "#9900FF", "#FF00FF",
				"#E6B8AF", "#F4CCCC", "#FCE5CD", "#FFF2CC", "#D9EAD3", "#D0E0E3", "#C9DAF8", "#CFE2F3", "#D9D2E9", "#EAD1DC",
				"#DD7E6B", "#EA9999", "#F9CB9C", "#FFE599", "#B6D7A8", "#A2C4C9", "#A4C2F4", "#9FC5E8", "#B4A7D6", "#D5A6BD",
				"#CC4125", "#E06666", "#F6B26B", "#FFD966", "#93C47D", "#76A5AF", "#6D9EEB", "#6FA8DC", "#8E7CC3", "#C27BA0",
				"#A61C00", "#CC0000", "#E69138", "#F1C232", "#6AA84F", "#45818E", "#3C78D8", "#3D85C6", "#674EA7", "#A64D79",
				"#85200C", "#990000", "#B45F06", "#BF9000", "#38761D", "#134F5C", "#1155CC", "#0B5394", "#351C75", "#741B47",
				"#5B0F00", "#660000", "#783F04", "#7F6000", "#274E13", "#0C343D", "#1C4587", "#073763", "#20124D", "#4C1130"];

		if (this.props.transparent) {
			colors.push({title: 'None', color: 'transparent'});
		}

		return colors;
	}

	render() {
		return (
			<div style={{ width: "100%"}}>
				<InputLabel
					sx={theme => ({
						backgroundColor: theme.palette.mode === 'dark' ? '#121212' : 'white',
						borderLeft: `7px solid ${theme.palette.mode === 'dark' ? '#121212' : 'white'}`,
						borderRight: `7px solid ${theme.palette.mode === 'dark' ? '#121212' : 'white'}`,
						marginLeft: '-5px'
					})}
					htmlFor="colorInput">
					{this.state.label}
				</InputLabel>
				<OutlinedInput
					style={{width: '100%', height: '40px', cursor: 'pointer' }}
					id="colorInput"
					inputProps={{
						style: { width: '0px', paddingRight: '6px' }
					}}
					startAdornment={
						<InputAdornment style={{ width: "100%" }} position="start">
							<div style={{ width: "100%" }}>
								<div
									style={{
										display: 'inline-block',
										width: '100%',
										// width: `${this.props.width}px`,
										height: '21px',
										marginTop: '8px',
									}}
									onClick={this.handleColorClick}
								>
									<div
										style={{
											width: '100%',
											height: '100%',
											borderRadius: '2px',
											background: this.getBackground(),
										}}
									/>
								</div>
								<Popover
									open={this.state.displayPicker}
									anchorEl={this.state.anchorEl}
									anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
									// targetOrigin={{ horizontal: 'left', vertical: 'top' }}
									onClose={this.handleColorClose}
								>
									<SketchPicker
										disableAlpha={this.props.disableAlpha}
										width={250}
										color={this.state.color}
										presetColors={this.getPresetColors()}
										onChange={this.handleColorChange}
									/>
								</Popover>
							</div>
						</InputAdornment>
					}
					// labelWidth={70}
				/>
			</div>
		);
	}
}
